
import API from '../config/api.js'

export const AuthService = {    
  
    login(data) {
        return API.post('/api/member/login', data);
    },

    register(data) {
        return API.post('/api/member/create', data);
    },

    logout(){
        return API.post('/api/logout');
    },

    reset(data){
        return API.post('/api/forgot-password', data);        
    },

    getProfile(){        
        return API.get('/api/member/profile');
    },
   
    updatePassword(data) {    
        return API.patch(`api/member/password`, data);
    }, 
    
    getUserRoles() {    
        return API.get(`api/user/roles`);
    }  

}



